import Field from "../../components/Field";
import React from 'react'
import i18n from '../../i18n'

export default function CountrySelectField (props) {
  const { countries } = props

  if (i18n.language === 'en') {
    countries.sort((a, b) => (a.name_en > b.name_en) ? 1 : -1)
  }

  return (
    <div className={'select-wrapper'}>
      <Field as="select" {...props}>
        <option value="">---</option>
        {i18n.language === 'de' && countries.map(
          country =>
            country.short === 'DE' && (
              <option key={country.short} value={country.short}>
                {country.name_de}
              </option>
            ),
        )}
        {i18n.language === 'de' && countries.map(
          country =>
            country.short !== 'DE' && (
              <option key={country.short} value={country.short}>
                {country.name_de}
              </option>
            ),
        )}
        {i18n.language === 'en' && countries.map(
          country =>
            country.short === 'DE' && (
              <option key={country.short} value={country.short}>
                {country.name_en}
              </option>
            ),
        )}
        {i18n.language === 'en' && countries.map(
          country =>
            country.short !== 'DE' && (
              <option key={country.short} value={country.short}>
                {country.name_en}
              </option>
            ),
        )}
      </Field>
    </div>
  )
}
